import React from "react";
import Icon, { ICON_COLORS, Icons } from "./Icons";

import { SpinnerContainer } from "./__styles__/FullPageLoadingScreen";

const FullPageLoadingScreen: React.FC = () => {
  return (
    <SpinnerContainer>
      <Icon icon={Icons.LOADING} color={ICON_COLORS.WHITE} />
    </SpinnerContainer>
  );
};

export default FullPageLoadingScreen;
